export const getStyleSkinName = () => {
  // if (window.location.href.includes('par')) return 'par';
  // else if (window.location.href.includes('esi')) return 'esi';
  // else if (window.location.href.includes('bib')) return 'bib';
  // else return '';
  return 'bib';
}